module.exports = __webpack_public_path__ + "img/FR18706.521944aa.png";